<div class="slideout-content">
    <div class="modalsd modal-slide-in sdfade new-user-modal" id="modals-slide-in">
        <div class="modal-dialog">
            <form class="add-new-user modal-content pt-0">
                <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        (click)="toggleSidebar()"
                >
                    ×
                </button>
                <div class="modal-header">
                    <h5 class="modal-title">Add Symptoms</h5>
                </div>
                <div class="modal-body flex-grow-1">
                    <form class="form mt-2 shadow-none" novalidate [formGroup]="addSymptomForm">
                        <div class="container">
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="name">Name</label>
                                        <input class="form-control" id="name" type="text" formControlName="name">
                                        <small class="text-danger">
                                            Field is required.
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <button type="reset" rippleEffect class="btn btn-danger" (click)="toggleSidebar()">
                                    Cancel
                                </button>
                                <button type="submit" rippleEffect class="btn btn-primary ml-1 pull-right"
                                        (click)="submit()" *ngIf="!data || !data['id']">
                                    Submit
                                </button>
                                <button type="submit" rippleEffect class="btn btn-primary ml-1 pull-right"
                                        (click)="update()" *ngIf="data && data['id']">Update
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </form>
        </div>
    </div>
</div>

